import type IsoDate from '../../../models/IsoDate';
import type StudyModel from '../../../models/StudyModel';
import { requestAndParse, requestSuccessful } from '../request';

const createStudy = async (
    name: string,
    startDate: IsoDate,
    length: number,
) => {
    const route = 'admin/create-study';
    const payload = { name, startDate, length };

    const response = await requestAndParse(route, payload);

    const success = requestSuccessful(response);
    const study = (response.body?.study ?? {}) as StudyModel;

    return { success, study };
};

export default createStudy;
